import { useSession } from "@clerk/clerk-react";
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@heroui/react";
import { Flag } from "@phosphor-icons/react";
import ButtonNew from "components/buttonNew/buttonNew";
import { EditableTextareaComponent } from "components/index";
import { API_URL } from "constants/index";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { RentalContract } from "shared/types/rental-contracts";

export enum WatchListModalState {
    FLAG,
    UNFLAG,
}

export interface FlagForWatchListModalProps {
    incomingState: WatchListModalState
    isOpen: boolean;
    onClose?: () => void;
    incomingContract: RentalContract | null;
    handleContractRefresh: (id?: number) => void;
}

export const FlagForWatchListModal = ({ isOpen, onClose, incomingContract, handleContractRefresh, incomingState }: FlagForWatchListModalProps) => {
    const [selectedContract, setSelectedContract] = useState<RentalContract | null>(null);
    const [modalState, setModalState] = useState<WatchListModalState>(incomingState);
    const [watchListReason, setWatchListReason] = useState<string | null>(null);
    const { session } = useSession();

    useEffect(() => {
        setSelectedContract(incomingContract);
    }, [incomingContract]);

    useEffect(() => {
        setModalState(incomingState);
    }, [incomingState]);

    const handleClose = () => {
        setSelectedContract(null);
        setWatchListReason(null);
        onClose && onClose();
    };

    const flagForWatchList = async () => {
        console.log("Logging incomingContract: ", incomingContract);
        console.log("Logging selectedContract: ", selectedContract);
        if (modalState == WatchListModalState.FLAG && incomingContract?.flaggedForWatchlist && !watchListReason) {
            return toast.error("Gelieve een reden op te geven waarom dit contract op de watchlist moet worden geplaatst.");
        }

        let payload = {
            incomingContractId: selectedContract?.id || incomingContract?.id,
            watchListReason: watchListReason || "",
        };

        console.log(payload);

        try {
            await fetchWithAuth(`${API_URL}/rental/contract/${selectedContract?.id}/watchlist/${modalState == WatchListModalState.FLAG ? "flag" : "unflag"}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            }, session);

            if(modalState == WatchListModalState.FLAG) {
                toast.success('Contract op watchlist geplaatst');
            } else {
                toast.success('Contract van de watchlist gehaald');
            }
        } catch (error) {
            console.error('Error activating contract', error);
        } finally {
            if(modalState == WatchListModalState.FLAG) {
                handleContractRefresh();
            } else {
                handleContractRefresh(selectedContract?.id);
            }

            setSelectedContract(null);
            setWatchListReason(null);
            handleClose();
        }
    };

    return (
        <Modal onClose={handleClose} isOpen={isOpen} isDismissable={true} isKeyboardDismissDisabled={true} className="font-normal text-neutral-primary" size="4xl" scrollBehavior="inside">
            <ModalContent>
                {(onClose) => (
                    <>
                        <ModalHeader className="flex flex-col gap-1">
                            <p className="flex items-center gap-1 text-sm font-medium text-status-bad">
                                <Flag className="h-[17px] w-[17px]" /> {modalState == WatchListModalState.FLAG ? "Haal contract van watchlist" : "Plaats contract op watchlist"}
                            </p>
                        </ModalHeader>
                        <ModalBody>
                            <p>Ben je zeker dat je dit contract {modalState == WatchListModalState.FLAG ? "op de watchlist wil plaatsen?" : "van de watchlist wil halen?"}</p>
                            {modalState == WatchListModalState.FLAG && <p>Zo ja, geef een reden in. Er zijn geen gevolgen. Dit contract wordt gewoon extra in de aandacht geplaatst onder de pagina verhuur ter opvolging.</p>}
                            {modalState == WatchListModalState.FLAG && <EditableTextareaComponent
                                value={watchListReason || ""}
                                onChange={(value) => setWatchListReason(value)}
                                label="Geef de reden om dit contract op de watchlist te plaatsen"
                                editMode={true}
                                isLoading={false}
                            />}
                        </ModalBody>
                        <ModalFooter className="justify-start">
                            <ButtonNew
                                variant="primaryStatusGreen"
                                onClick={flagForWatchList}
                                icon={<Flag />}
                                label={`${modalState == WatchListModalState.FLAG ? "Plaats contract op watchlist" : "Haal contract van watchlist"}`}
                            />
                            <ButtonNew
                                variant="secondaryNeutral"
                                onClick={onClose}
                                label="Cancel"
                            />
                        </ModalFooter>
                    </>
                )}
            </ModalContent>
        </Modal>
    );
};
